import styled from "styled-components";

export const Section = styled.div`
  display: flex;
  flex: 1;
  background-color: #f2f4f8;
  max-width: 100vw !important;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 32px;
  margin-top: 50px;
  max-width: 100vw !important;
`;

export const HeaderFrame = styled.div`
  margin: 0 auto;
  width: 92%;
  background: linear-gradient(
    268.28deg,
    rgba(6, 217, 134, 0.3) 0%,
    rgba(74, 118, 251, 0.3) 100%
  );
  border-radius: 16px 16px 0px 0px;
  overflow: auto;
`;

export const BodyFrame = styled.div`
  display: flex;
  padding: 32px 32px 32px 32px;
  overflow: hidden;
  background: #ffffff;
  border-radius: 8px;
  max-width: 100vw !important;
  max-height: auto !important;
`;
